export function CashIcon({ width = 30 }: { width?: number }) {
  return (
    <svg
      width={width}
      aria-hidden="true"
      height="22"
      viewBox="0 0 30 22"
      fill="#239E45"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M24.3335 13.5785V2.91178C24.3335 1.44512 23.1335 0.245117 21.6668 0.245117H3.00016C1.5335 0.245117 0.333496 1.44512 0.333496 2.91178V13.5785C0.333496 15.0451 1.5335 16.2451 3.00016 16.2451H21.6668C23.1335 16.2451 24.3335 15.0451 24.3335 13.5785ZM12.3335 12.2451C10.1202 12.2451 8.3335 10.4585 8.3335 8.24512C8.3335 6.03178 10.1202 4.24512 12.3335 4.24512C14.5468 4.24512 16.3335 6.03178 16.3335 8.24512C16.3335 10.4585 14.5468 12.2451 12.3335 12.2451ZM29.6668 4.24512V18.9118C29.6668 20.3785 28.4668 21.5785 27.0002 21.5785H4.3335V18.9118H27.0002V4.24512H29.6668Z" />
    </svg>
  );
}
